import React from "react";
import ct from "class-types.macro";
import LoginLink from "./LoginLink";
import GetPriceByEmail from "./GetPriceByEmail";
import { VariantProps } from ".";
const P = ({
  selectedProduct,
  productListingView,
  displayOutletCallForPricing = false
}: VariantProps) => {
  return <div data-sentry-component="P" data-sentry-source-file="P.tsx">
      {selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers && !displayOutletCallForPricing ? <Paragraph productListingView={productListingView}>
          <LoginLink>Login</LoginLink>
          {" or enter your email to be instantly sent the price!"}
        </Paragraph> : <Paragraph productListingView={productListingView}>
          Enter your email to be instantly sent the price!
        </Paragraph>}
      <div className={ct("whitespace-nowrap", "mx-auto", "mb-0", "mt-1-1/4")}>
        <GetPriceByEmail itemNumber={selectedProduct.itemNumber} data-sentry-element="GetPriceByEmail" data-sentry-source-file="P.tsx" />
      </div>
    </div>;
};
function Paragraph({
  children,
  productListingView
}: {
  children: React.ReactNode;
  productListingView?: string;
}) {
  return <p className={ct("font-semibold", "text-xs", "leading-none", "mb-0", "p-0", "text-gray-800", productListingView === "list" ? ct("mt-1", "max-w-full", "xs:mx-auto", "xs:mt-0", "xs:text-center", "xs:w-40") : ct("pt-1", "text-center"))} data-sentry-component="Paragraph" data-sentry-source-file="P.tsx">
      {children}
    </p>;
}
export default P;